<template>
  <div class="compressed-content">
    <h3 class="page-question">
      Have you ever had ANY of the following procedures to fix a blocked leg artery?<br /><i>(Check all that apply)</i>
    </h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.procedures">
      <b-form-checkbox v-model="survey.arteryBlockages.blockedLegArteryProcedures.hadNoSurgery"
                       @change="onNoProcedureSelected">
        No
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.arteryBlockages.blockedLegArteryProcedures.hadBalloonOpening"
                       @change="onBalloonOpeningSelected">
        Balloon opening of a blocked leg artery
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.arteryBlockages.blockedLegArteryProcedures.hadStent"
                       @change="onStentSelected">
        Stent of a blocked leg artery
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.arteryBlockages.blockedLegArteryProcedures.hadBypassSurgery"
                       @change="onBypassSurgerySelected">
        Bypass surgery of a blocked leg artery
      </b-form-checkbox>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');
  import { anyOptionRequired } from 'utils/custom-validators';

  export default {
    mixins: [formMixin],

    validations: {
      procedures: {
        anyOptionRequired: anyOptionRequired((value) => value.hadNoSurgery || value.hadBalloonOpening
          || value.hadStent || value.hadBypassSurgery)
      }
    },

    computed: {
      ...mapState(["survey"]),

      procedures() { return this.survey.arteryBlockages.blockedLegArteryProcedures; }
    },

    methods: {
      onNoProcedureSelected(value) {
        this.setOptions(value, false, false, false);
      },

      onBalloonOpeningSelected(value) {
        this.setOptions(false, value, this.procedures.hadStent, this.procedures.hadBypassSurgery);
      },

      onStentSelected(value) {
        this.setOptions(false, this.procedures.hadBalloonOpening, value, this.procedures.hadBypassSurgery);
      },

      onBypassSurgerySelected(value) {
        this.setOptions(false, this.procedures.hadBalloonOpening, this.procedures.hadStent, value);
      },

      setOptions(hadNoSurgery, hadBalloonOpening, hadStent, hadBypassSurgery) {
        this.survey.arteryBlockages.blockedLegArteryProcedures.hadNoSurgery = hadNoSurgery;
        this.survey.arteryBlockages.blockedLegArteryProcedures.hadBalloonOpening = hadBalloonOpening;
        this.survey.arteryBlockages.blockedLegArteryProcedures.hadStent = hadStent;
        this.survey.arteryBlockages.blockedLegArteryProcedures.hadBypassSurgery = hadBypassSurgery;
      }
    }
  };
</script>